import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * Shared hook: opens native Google popup, verifies credential with OG MUSIC backend.
 * Never redirects through auth.emergentagent.com.
 */
export function useGoogleAuth({ onSuccess, onError }) {
  const login = useGoogleLogin({
    flow: 'implicit',
    onSuccess: async (tokenResponse) => {
      try {
        // Get user info from Google using the access token
        const userInfoRes = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });
        const userInfo = await userInfoRes.json();

        // Send to OG MUSIC backend for verification and JWT creation
        const res = await axios.post(
          `${API_URL}/api/auth/google/verify`,
          { credential: tokenResponse.access_token, userinfo: userInfo },
          { withCredentials: true }
        );
        onSuccess(res.data);
      } catch (err) {
        console.error('Google auth error:', err);
        onError(err?.response?.data?.detail || 'Error al autenticar con Google');
      }
    },
    onError: (err) => {
      console.error('Google login error:', err);
      onError('No se pudo iniciar sesión con Google');
    },
  });

  return login;
}
